import React, { useEffect, useState, lazy } from "react";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "../../../_actions/cart.actions";
import axios from "../../../axios";
import CustomBreadCrumb from "@pages/Other/CustomBreadCrumb";
import { Loading } from "@pages/Other/Loading";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import CoursePreview from "../CoursePreview/CoursePreview";
import RenderRating from "@pages/Other/StarRating/RenderRating";
import RateCourse from "@pages/Other/StarRating/RateCourse";
import "../CourseDetails/courseDetails.scss";
import ChapterOverView from "./chapterOverView";
import { getS3URL, handleViewsFormat } from "../../../_helpers";
import { AuthorizedWrapper } from "@pages/Other/AuthorizedWrapper";
import CartButton from "../CourseTile/CartButton/CartButton";
import Share from "../CourseShare/courseShare";
import { courseActions } from "../../../_actions";
import { deleteWishlist, addWishlist } from "../../../_actions/cart.actions";
import moment from "moment/moment";
import { useNavigate, useParams } from "react-router-dom";
import { CourseSeo } from "@components/fetchSeoMeta";

function CourseDetail({ match }) {
  const { slug } = useParams();
  const slugParts = slug.split("-");
  const courseName = slugParts.slice(0, -1).join("-");
  const courseId = slugParts.pop();
  //console.log("courseIdcourseIdcourseId123", courseId);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loggedIn } = useSelector((state) => state.authentication);
  //console.log("loggedIn", loggedIn);
  const param = slugParts;
  // const param = match.params.courseId.match(/\w[^-]*$/g);
  const [course, setCourse] = useState(null);
  const [showCoursePreview, setShowCoursePreview] = useState(false);
  const [showRateCourseModal, setShowRateCourseModal] = useState(false);
  const [shareShow, setShareShow] = useState(false);
  const [rating, setRating] = useState(0);
  const [rateLogin, setRateLogin] = useState(true);
  const [favourite, setFavourite] = useState(false);
  const [courseHistory, setCourseHistory] = useState([]);

  // Define the function that fetches the data from API
  const fetchData = async (courseId) => {
    try {
      //console.log("courseId", courseId);
      const response = await axios.get(`course/${courseId}`);
      //console.log("response.data.data", response.data.data);
      setCourse(response?.data?.data);
      setRating(response?.data?.data?.Rating);
      setFavourite(Boolean(response.data.data.isWishlisted));
    } catch (error) {
      console.error("Error fetching course data:", error);
    }
  };


  const handleCourseViews = async (courseId) => {
    try {
      await axios.post(`course/${courseId}/views`);
    } catch (error) {
      console.error("Error updating course views:", error);
    }
  };

  const handleCoursePreview = (event) => {
    event.preventDefault();
    setShowCoursePreview(true);
  };

  const firstName = course?.instructorInfo?.firstName;
  const lastName = course?.instructorInfo?.lastName;

  const handleCloseModal = () => {
    setShowRateCourseModal(false);
  };

  const handleShowModal = () => {
    setShowRateCourseModal(true);
  };

  const handleAddCourseToCart = (event, course) => {
    event.preventDefault();
    dispatch(addToCart(course.ID));
  };

  useEffect(() => {
    if (slug && courseId) {
      // Only fetch data if course hasn't been loaded yet
      if (!course) {
        fetchData(courseId);
      }
    }
  }, [slug, courseId, course]);


  const handleClose = () => {
    setShareShow(!shareShow);
  };
  const likeHandler = (courseId, isWishlisted) => {
    if (loggedIn && favourite) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(deleteWishlist(courseId));
      setFavourite(false);
    } else if (loggedIn && !favourite) {
      dispatch(courseActions.handleResetCourseList());
      dispatch(addWishlist(courseId));
      setFavourite(true);
    } else {
      navigate("/login");
    }
  };

  const handleRate = () => {
    if (!loggedIn) {
      navigate("/login");
    }
  };
  const handleRateCourse = (courseId) => {
    const Courserating = {
      courseId: courseId,
      rating: rating,
    };

    setShowRateCourseModal(false);
  };

  useEffect(() => {
    if (course) {
      setCourseHistory([
        course.Category,
        course.SubCategory
      ]);
    }
  }, [course]);

  // console.log("course.isPurchased", course);

  return (
    <>
      <CourseSeo course={course} />
      {course === null ? (
        <div className="loading-div">
          <Loading />
        </div>
      ) : (
        <div>
          <div className="min-div">
            <div className="inner-div">
              <div className="flex-wrap">
                <CustomBreadCrumb courseHistory={courseHistory} />
                {loggedIn &&
                  <div className="int-flex-wrapper">
                    <div
                      className="wishlist-wrapper"
                      onClick={() => likeHandler(courseId, course?.isWishlisted)}
                    >
                      <span
                        className={`icon ${!favourite ? "icon-like" : "icon-liked"
                          } `}
                      ></span>{" "}
                    </div>

                    <div className="share-course-wrapper" onClick={handleClose}>
                      <i className="topic-share-icon"></i>
                    </div>
                  </div>
                }
              </div>

              <div className="course-banner-main">
                <div className="banner-course-left">
                  <div className="course-header">{course?.CourseName}</div>
                  <div className="banner-sub">{course?.courseOneLiner}</div>
                  <div className="EnrollmentFee">
                    <div className="course-price-wrapper">
                      {course.isPurchased ? (
                        <div className="purchase-wrapper">
                          {t("Purchased Course")}
                        </div>
                      ) : (
                        <>
                          <div className="course-price">
                            <span>{course && course.EnrollmentFee}</span>
                          </div>
                          {/* <div className="coupon-code">
                            <ul>
                              <li>Got a Discount code?</li>
                              <li></li>
                            </ul>
                          </div> */}
                        </>
                      )}
                    </div>

                    <div className="star-rateingmenu">
                      <div className="rating-title">
                        <div className="sub-title">{t("Reviews")}</div>
                        <div className="ratings-wrapper">
                          <RenderRating
                            loggedIn={loggedIn}
                            rateLogin={rateLogin}
                            ratings={
                              rating === 0 ? Number(course.Rating) : rating
                            }
                            handleRate={handleRate}
                            handleShowModal={handleShowModal}
                          />
                          {loggedIn && (
                            <div
                              className="rate-course-title"
                              onClick={handleShowModal}
                            >
                              {t("Rate this Course?")}
                            </div>
                          )}
                          {/* {showRateCourseModal && (
                            <RateCourse onClose={handleCloseModal} />
                          )} */}
                          {showRateCourseModal &&
                            loggedIn &&
                            (course.isPurchased ? (
                              <RateCourse
                                onClose={handleCloseModal}
                                rating={rating}
                                setRating={setRating}
                                handleRateCourse={handleRateCourse}
                                course={course}
                                showRateCourseModal={showRateCourseModal}
                                setShowRateCourseModal={setShowRateCourseModal}
                              />
                            ) : (
                              <div className="rate-course rate-course-login">
                                <div className="arrow-up"></div>
                                <div
                                  className="close-button-login"
                                  onClick={() => setShowRateCourseModal(false)}
                                >
                                  <i className="icon check"></i>
                                </div>
                                <div className="star-text">
                                  Please buy this course first !
                                </div>

                                <div className="button-wrapper">
                                  <div
                                    className="btn btn-back"
                                    onClick={() =>
                                      setShowRateCourseModal(false)
                                    }
                                  >
                                    <a>Later</a>
                                  </div>
                                </div>
                              </div>
                            ))}
                        </div>
                      </div>
                      <div>
                        <p className="sub-title">
                          {t("Course views")} &nbsp;
                          {handleViewsFormat(
                            course?.courseViews === null
                              ? 0
                              : course.courseViews
                          )}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="banner-profile-div">
                    <div className="banner-profile-left">
                      <img
                        src={`${course?.instructorInfo?.profileImage !== null
                          ? course?.instructorInfo?.profileImage
                          : "https://cdn-icons-png.flaticon.com/512/147/147144.png"
                          }`}
                        alt=""
                      />
                    </div>

                    <div className="banner-profile-right">
                      <div className="banner-header">
                        {`${firstName} ${lastName}`}
                      </div>
                      <div className="banner-sub-text">
                        {t("Instructor Profile")}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="banner-course-right">
                  <div className="flex-right">
                    <ul>
                      {/* <li className="pre-btn">
                        {" "}
                        <a
                          href="/#"
                          role="button"
                          onClick={handleCoursePreview}
                        >
                          <span>{t("Preview Course")}</span>
                        </a>{" "}
                      </li> */}
                      {!loggedIn &&
                        <li className="Basket">
                          <CartButton post={course} />
                        </li>
                      }
                      {!course.isPurchased && (
                        <AuthorizedWrapper authorizedRoles={["Student"]}>
                          <li className="Basket">
                            <CartButton post={course} />
                          </li>
                        </AuthorizedWrapper>
                      )}
                    </ul>

                    <div className="course-info-wrapper">
                      <div className="banner-sub2">
                        <ul>
                          <li>{t("Languages")}:</li>
                          <li>{t(course.Language)}</li>
                        </ul>
                      </div>

                      <div className="banner-sub2">
                        <ul>
                          <li>
                            {t("Created on")}:{" "}
                            {moment(course?.CreatedOn).format("MMM DD, YYYY")}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showCoursePreview && (
            <OverlayContainer>
              <CoursePreview
                courseName={course.CourseName}
                courseImg={getS3URL(course.imageFiles[0].fileName)}
                courseVid={getS3URL(course.videoFiles[0].fileName)}
                toogle={setShowCoursePreview}
              />
            </OverlayContainer>
          )}

          {course && <ChapterOverView course={course} />}

          {shareShow && <Share handleClose={handleClose} />}
        </div>
      )}
    </>
  );
}
export default CourseDetail;
